export const PARTICIPANTS_SAVE_STARTED = 'CREDIT_APP_PARTICIPANTS_SAVE_STARTED';
export const PARTICIPANTS_SAVE_FINISHED_WITHOUT_COPY = 'CREDIT_APP_PARTICIPANTS_SAVE_FINISHED_WITHOUT_COPY';
export const CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE = 'CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE';
export const CREDIT_APP_UPDATED_ALERT_DISMISSED = 'CREDIT_APP_UPDATED_ALERT_DISMISSED';
